const getAllCategory = async (fun) => {
  try {
    const res = await fun();
    return res?.data;
  } catch (error) {
    // console.log("error", error);
  }
};

export { getAllCategory };
